import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Privacy } from './components/legal/Privacy'
import { Tos } from './components/legal/Tos'
import ReactGA from 'react-ga4'
import ErrorBoundary from './ErrorBoundary'
import reportWebVitals from './reportWebVitals'
import { AlertProvider } from './context/AlertContext'
import { FeatureFlagsProvider } from './context/FeaturesContext'
import { LoadingProvider } from './context/XsollaLoaderContext'
import { AchievementsProvider } from './context/AchievementsContext'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { User } from './lib/user'
import { RequireUser } from './components/user/RequireUser'
import {
  GAME_MODE_UNLIMITED,
  GAME_MODE_DAILY,
  GAME_MODE_MINI_DAILY,
  GAME_MODE_CUSTOM,
  GAME_MODE_TIPS,
  GAME_MODE_ACHIEVEMENTS,
} from './constants/strings'
import { GA_MEASUREMENT_ID } from './constants/settings'
ReactGA.initialize(GA_MEASUREMENT_ID)

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <FeatureFlagsProvider>
        <AlertProvider>
          <LoadingProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/tos" element={<Tos />} />
                <Route
                  path="/tips"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_TIPS}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/achievements"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_ACHIEVEMENTS}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/daily/:index"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_DAILY}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/mini"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_MINI_DAILY}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/mini/:index"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_MINI_DAILY}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/:puzzleId/:seed"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_UNLIMITED}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="/custom/:puzzleId/:seed"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_CUSTOM}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
                <Route
                  path="*"
                  element={
                    <RequireUser pplus={false}>
                      {(user: User, setUser: (user: User) => void) => (
                        <App
                          mode={GAME_MODE_DAILY}
                          user={user}
                          setUser={setUser}
                        />
                      )}
                    </RequireUser>
                  }
                />
              </Routes>
            </BrowserRouter>
          </LoadingProvider>
        </AlertProvider>
      </FeatureFlagsProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
